import React, { Component } from "react";
import { connect } from "react-redux";
import "react-datetime/css/react-datetime.css";
import CustomScroll from "react-custom-scroll";

import { BreachInfo } from "./BreachInfo";
import { Form } from "./Form";

class ReportBreach extends Component {
  state = { sendForm: false };

  render() {
    const { sendForm } = this.state;
    const { _ } = this.props;
    return (
      <div className="report-breach">
        <h2 className="ml-3">{_.ClientHub.ReportBreach}</h2>
        {!sendForm ? (
          <CustomScroll
            heightRelativeToParent={"calc(100% - 100px)"}
            allowOuterScroll={true}
          >
            <Form
              _={_}
              sendForm={(payload) => {
                this.setState(payload);
              }}
            ></Form>
          </CustomScroll>
        ) : (
          <BreachInfo
            _={_}
            openNewForm={() =>
              this.setState({
                sendForm: false,
                formValues: this.state.formValues,
              })
            }
            formValues={this.state.formValues}
          />
        )}
      </div>
    );
  }
}

export const mapStateToProps = ({ _ }) => ({ _ });
export default connect(mapStateToProps)(ReportBreach);
